import * as actionTypes from '../../actionTypes';
import createReducer from '../../../../common/utils/createReducer';
import get from 'lodash/get';

const INITIAL_STATE = {
  isLoading: false,
  photoAssistConfig: {},
  photoTipsConfig: {},
  sampleImages: {},
  imageUploadStrings: {},
  uploadImagesWidgetLoadingState:false,
  imageCompressionConfig: undefined
}

const reducer = {
  [actionTypes.SET_LOADING_STATUS]: (state, action) => {
    const { isLoading } = action.payload;
    return {
      ...state,
      isLoading: isLoading
    }
  },
  [actionTypes.UPLOAD_IMAGES_WIDGET_LOADING_STATE]: (state, action) => {
    const { isLoading } = action.payload;
    return {
      ...state,
      uploadImagesWidgetLoadingState: isLoading
    }
  },
  [actionTypes.FETCH_PHOTO_ASSIST_CONFIG_SUCCESS]: (state, action) => {
    const { configData } = action.payload
    return {
      ...state,
      isLoading: false,
      photoAssistConfig: configData
    }
  },
  [actionTypes.FETCH_PHOTO_ASSIST_CONFIG_FAILED]: (state, action) => {
    return {
      ...state,
      isLoading: false,
    }
  },
  [actionTypes.FETCH_PHOTO_TIPS_CONFIG_SUCCESS]: (state, action) => {
    const { configData } = action.payload
    return {
      ...state,
      isLoading: false,
      photoTipsConfig: configData
    }
  },
  [actionTypes.FETCH_IMAGE_COMPRESSION_CONFIG]: (state, action) => {
    const { configData } = action.payload;
    return {
      ...state,
      imageCompressionConfig: get(configData, 'imageCompressionConfig', [])
    }
  },
  [actionTypes.FETCH_SAMPLE_IMAGES_SUCCESS]: (state, action) => {
    const { configData } = action.payload
    return {
      ...state,
      isLoading: false,
      sampleImages: configData
    }
  },
  [actionTypes.SET_IMAGE_UPLOAD_STRINGS]: (state, action) => {
    const { strings } = action.payload
    return {
      ...state,
      isLoading: false,
      imageUploadStrings: strings
    }
  },
  [actionTypes.FETCH_PHOTO_TIPS_CONFIG_FAILED]: (state, action) => {
    return {
      ...state,
      isLoading: false,
    }
  },
  [actionTypes.FETCH_IMAGES_CONFIG_FAILED]: (state, action) => {
    return {
      ...state,
      isLoading: false,
    }
  },
  [actionTypes.FETCH_SAMPLE_IMAGES_FAILED]: (state, action) => {
    return {
      ...state,
      isLoading: false,
    }
  }
}

export default createReducer(INITIAL_STATE, reducer);
